define('pwa/plugin/tickets/view/TicketsLayoutView',['require','marionette','pwa/plugin/tickets/view/TicketsListView','pwa/plugin/tickets/collection/TicketsCollection'],function (require) {

    var Marionette = require('marionette');
    var TicketsListView = require('pwa/plugin/tickets/view/TicketsListView');
    var TicketsCollection = require('pwa/plugin/tickets/collection/TicketsCollection');

    /**
     * Tickets layout
     *
     * @class TicketsLayout
     */
    return Marionette.LayoutView.extend({

        template: '#tickets_layout_view',
        regions: {
            ticketsList: '#sb_tickets_list',
        },
        _clientModel: null,

        initialize: function () {
            this._data = this.getOption('data');
        },

        onBeforeShow: function () {
            var collection = new TicketsCollection();

            var data = {};

            if (this._data.type) {
                data.type = this._data.type;
            }

            collection.fetch({
                data: data
            });

            this._clientModel = this.getOption('clientModel');

            this.listenTo(this._clientModel, 'sync', function () {
                collection.fetch({
                    data: data
                });
            });

            this.showChildView('ticketsList', new TicketsListView({
                collection: collection,
                collectionData: data,
                data: this._data,
                clientModel: this._clientModel
            }));
        },

        serializeData: function () {
            var result = Marionette.LayoutView.prototype.serializeData.apply(this);
            result.type = this._data.type;

            return result;
        },

        onDomRefresh: function () {
            Backbone.Wreqr.radio.vent.trigger('page', 'shown', {
                'page': 'my_tickets'
            });
        },


    });

});
